import React from 'react';
import { TEST_IDS } from '@constants/testIds.ts';
import {
    SHARED_CARD_INFO_DATES_ASSIGNED,
    SHARED_CARD_INFO_DATES_COMPLETED,
    SHARED_CARD_INFO_DATES_DUE,
    SHARED_CARD_INFO_DATES_PASSED,
} from '@routes/sidebar/notifications/ui/card-info-dates/constants.ts';
import {
    AssignedText,
    CardInfoDatesWrapper,
    DueText,
} from '@routes/sidebar/notifications/ui/card-info-dates/styled.tsx';
import { translateItem } from '@utils/translations.ts';

interface Props {
    assignedDate: string;
    statusDate: string;
    isOverdue?: boolean;
    isCompleted?: boolean;
    isPassed?: boolean;
    dueDate: string | null;
}

const CardInfoDates: React.FC<Props> = ({
    assignedDate,
    statusDate,
    isOverdue = false,
    isCompleted = false,
    isPassed = false,
    dueDate = null,
}) => {
    const ASSIGNED = translateItem(SHARED_CARD_INFO_DATES_ASSIGNED);
    const DUE = translateItem(SHARED_CARD_INFO_DATES_DUE);
    const COMPLETED = translateItem(SHARED_CARD_INFO_DATES_COMPLETED);
    const PASSED = translateItem(SHARED_CARD_INFO_DATES_PASSED);
    const STATUS_TEXT = isCompleted ? COMPLETED : isPassed ? PASSED : DUE;

    return (
        <CardInfoDatesWrapper>
            <AssignedText data-cy={TEST_IDS.NOTIFICATIONS.CARD_INFO_DATES_ASSIGNED}>
                {ASSIGNED}: {assignedDate}
            </AssignedText>
            {!!dueDate && (
                <DueText
                    $isOverdue={isOverdue}
                    $isCompletedOrPassed={isCompleted || isPassed}
                    data-cy={TEST_IDS.NOTIFICATIONS.CARD_INFO_DATES_STATUS}
                >
                    | {STATUS_TEXT}: {statusDate}
                </DueText>
            )}
        </CardInfoDatesWrapper>
    );
};

export default CardInfoDates;
